import { useMemo } from 'react'

/**
 * Hook to access the hide_pricing setting for the current project.
 * Returns true if pricing should be hidden for shared projects, false otherwise.
 * Works both inside and outside of Form components by using global project form.
 */
export const useHidePricing = (): boolean => {
  return useMemo(() => {
    // Try to get hide_pricing from global project form first
    try {
      if (window.projectForm) {
        const projectData = window.projectForm.getState().values
        return projectData.hide_pricing || false
      }
    } catch (error) {
      console.warn('Could not access project data for hide_pricing setting:', error)
    }

    // Default to false if we can't access project data
    return false
  }, [])
}
